"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amount = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const Amount = ({ value, currency = '$', className }) => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return (0, jsx_runtime_1.jsx)("span", { className: "text-fg-muted", children: "\u2014" });
    }
    const negative = value < 0;
    return ((0, jsx_runtime_1.jsxs)("span", { className: (0, utils_1.cn)('whitespace-nowrap', negative && 'text-red-600 dark:text-red-400', className), children: [negative && '-', currency, Math.abs(value).toLocaleString()] }));
};
exports.Amount = Amount;
exports.Amount.displayName = 'Amount';
